/** @file Sends presence frames: the selection-derived name on change, and again after every (re)connect. */
import { currentDoc } from '../../stores/currentDoc';
import { docStore } from '../../stores/docStore';
import { selectionStore } from '../../stores/selectionStore';
import { editingName } from './editingName';
import type { SyncSession } from './liveSession';

/** Subscribes to the selection and the document; `resend` after a hello (the server forgets presence per socket). */
export function watchPresence(session: SyncSession): { resend(): void; stop(): void } {
  let sent: string | null = null;
  const update = (fresh: boolean): void => {
    const editing = editingName(currentDoc(docStore.getState()), selectionStore.getState());
    // A new socket starts at null on the server, so only a non-null name needs resending after hello.
    if (fresh) sent = null;
    if (editing === sent) return;
    if (session.send({ t: 'presence', editing })) sent = editing;
  };
  const stops = [selectionStore.subscribe(() => { update(false); }), docStore.subscribe(() => { update(false); })];
  return {
    resend: () => { update(true); },
    stop: () => { for (const stop of stops) stop(); },
  };
}
